export default "__VITE_ASSET__DvkpQ9j6__"